import React, { useState, useEffect } from 'react';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import { TextField, List, ListItem, ListItemText, Paper } from '@mui/material';

const LocationSearchInput = props => {
    const [state, setState] = useState({
        address: props.initialAddress || '',
        location: {},
    });

    useEffect(() => {
        if (props.error) {
            setState({
                ...state,
                errorText: 'Please enter a valid address',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.error]);

    const searchOptions = {
        //This location targets the middle of Australia with a circle around Australia
        //This means that searches for addresses are preferred in Australia location
        location: new window.google.maps.LatLng(-27.928503, 134.379578),
        radius: 2188038,
        types: [props.searchType],
    };

    const handleChange = addressChange => {
        props.onChange(addressChange);
        setState({
            ...state,
            address: addressChange,
            errorText: '',
        });
    };

    const handleSelect = async address => {
        let addressLatLng = {};
        addressLatLng.address = address;
        addressLatLng.LatLng = await geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(({ lat, lng }) => {
                return { lat: lat, lng: lng };
            })
            .catch(error => console.error('Error', error));
        props.onSelect(addressLatLng);
        setState({
            ...state,
            address: addressLatLng.address,
            addressLatLng: addressLatLng,
        });
    };

    return (
        <PlacesAutocomplete
            value={state.address}
            onChange={handleChange}
            onSelect={handleSelect}
            debounce={250}
            searchOptions={searchOptions}
        >
            {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
            }) => (
                <>
                    <TextField
                        error={props.error}
                        helperText={state.errorText}
                        id="addressNew"
                        data-cy="address"
                        label="Address"
                        variant="outlined"
                        sx={props.sx}
                        {...getInputProps({
                            //pass down props: {props.disabled} to allow this field to be disabled
                            placeholder: 'Search Places ...',
                        })}
                        autoComplete="off"
                    />
                    {(suggestions.length > 0 || loading) && (
                        <Paper>
                            <List
                                component="nav"
                                sx={{ flexGrow: 1 }}
                                aria-label="places selection"
                            >
                                {loading && <ListItem>Loading...</ListItem>}
                                {suggestions.map((suggestion, index) => {
                                    const className = suggestion.active
                                        ? 'suggestion-item--active'
                                        : 'suggestion-item';
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                        ? {
                                              backgroundColor: '#fafafa',
                                              cursor: 'pointer',
                                          }
                                        : {
                                              backgroundColor: '#ffffff',
                                              cursor: 'pointer',
                                          };
                                    return (
                                        <ListItem
                                            button
                                            key={index}
                                            {...getSuggestionItemProps(
                                                suggestion,
                                                {
                                                    className,
                                                    style,
                                                }
                                            )}
                                        >
                                            <ListItemText
                                                primary={suggestion.description}
                                            ></ListItemText>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </Paper>
                    )}
                </>
            )}
        </PlacesAutocomplete>
    );
};

export default LocationSearchInput;
